import { Component, Input } from '@angular/core';
import { MenuService } from '../mega-menu.service.component';
import { StateService } from '@uirouter/angular';

@Component({
    selector: 'project-menu',
    template: require('./project-menu.component.html'),
  })
  export class ProjectMenuComponent {
    @Input() projectMenu: any;
  
    sortedTrackers: any;
  
    constructor(private menuService: MenuService, protected stateService: StateService) {
    }

    private init() {
      this.sortedTrackers = this.projectMenu.trackers.sort((a, b) => a.trackerName.localeCompare(b.trackerName));
    }

    moduleAvailable(moduleName) {
      return this.menuService.moduleAvailable(this.projectMenu, moduleName);
    }

    anyTrackersAvailable() {
      return this.menuService.anyTrackersAvailable(this.projectMenu);
    }

    isProjectMember() {
      return this.menuService.isProjectMember(this.projectMenu);
    }


    ngOnInit() {
      this.init();
    }

    ngOnChanges() {
      this.init();
    }

    trackByFn(index: number, item: any): any {
        return item?.id ?? item;
    }
}

